var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrundig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99.705,
    height: 10.853,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#bb442a;fill-rule:evenodd}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grundig"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-1",
    d: "M56.931.1h4.306v7.176A1.316 1.316 0 0 0 62.559 8.6h3.046V.1h4.306v10.722h-9.542a3.241 3.241 0 0 1-3.449-3.557V.1z",
    transform: "translate(-24.628 -.043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    className: "cls-1",
    d: "M97.3 10.779H93V3.614A1.3 1.3 0 0 0 91.673 2.3h-3.018v8.481H84.27V0h9.53a3.245 3.245 0 0 1 3.5 3.557z",
    transform: "translate(-36.463)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    className: "cls-1",
    d: "M10.03 8.555V4.822h4.249v6.031H5.838c-7.721-.017-7.846-10.9 0-10.853h7.375v2.3H8.107c-4.777.091-4.777 6.24-.113 6.24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    className: "cls-1",
    d: "M140.03.1h4.346v10.682h-4.346V.1z",
    transform: "translate(-60.589 -.043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    className: "cls-1",
    d: "M160.433 8.555V4.822h4.367v5.957h-8.51c-7.738.045-7.869-10.836 0-10.779h7.347v2.3h-5.049c-4.794.091-4.794 6.24-.113 6.24z",
    transform: "translate(-65.091)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    className: "cls-1",
    d: "M29.72 10.814h4.306V7.1h2.354a1.526 1.526 0 0 1 1.549.976l1.265 2.74h4.476c-1.345-3.092-1.407-3.926-2.581-4.765C43.733 4.913 43.358.171 39.194.08H29.72zM34.083 2.3h2.757c1.969.091 1.969 2.456 0 2.468h-2.757V2.332z",
    transform: "translate(-12.859 -.034)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    className: "cls-1",
    d: "M116 2.354h1.895c4.624.091 4.624 6.24 0 6.24H116zm-4.306 8.51h8.206c8.118 0 8.056-10.512.057-10.734h-8.267v10.705z",
    transform: "translate(-48.327 -.056)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrundig);
export default __webpack_public_path__ + "static/media/grundig.378168a85a7a1e06a0bce5ea76d69bba.svg";
export { ForwardRef as ReactComponent };